<template>
  <div class="data-time-wrapper text-right text-shadow-strong ">
      <div class="wrapper">
        <div class="date">{{date}}</div>
        <div class="time">{{time}}</div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            time: null,
            date: null
        }
    },
    created() {
        this.updateClock();
        this.getCurrentDate();
        setInterval(() => {
            this.updateClock();
            this.getCurrentDate();
        }, 1000);
    },
    methods: {
        updateClock () {
            var currentTime = new Date ();

            var currentHours = currentTime.getHours ( );
            var currentMinutes = currentTime.getMinutes ( );
            var currentSeconds = currentTime.getSeconds ( );

            // Pad the minutes and seconds with leading zeros, if required
            currentMinutes = ( currentMinutes < 10 ? "0" : "" ) + currentMinutes;
            currentSeconds = ( currentSeconds < 10 ? "0" : "" ) + currentSeconds;

            // Choose either "AM" or "PM" as appropriate
            var timeOfDay = ( currentHours < 12 ) ? "AM" : "PM";

            // Convert the hours component to 12-hour format if needed
            currentHours = ( currentHours > 12 ) ? currentHours - 12 : currentHours;

            // Convert an hours component of "0" to "12"
            currentHours = ( currentHours == 0 ) ? 12 : currentHours;

            // Compose the string for display
            var currentTimeString = currentHours + ":" + currentMinutes + ":" + currentSeconds + " " + timeOfDay;

            // Update the time display
            this.time = currentTimeString;
        },

        getCurrentDate() {
            var d = new Date(),
            months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
            days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
            this.date = days[d.getDay()]+' '+months[d.getMonth()]+' '+d.getDate()+' '+d.getFullYear();
        }
    }
}
</script>

<style lang="scss">
.data-time-wrapper {
    font-size: 1.7rem;
    .wrapper {
        border-left: 2px solid white;
        float: right;
        padding-left: 30px;
    }
}

 //lg
@media (max-width: 1279.98px) { 
    .data-time-wrapper {
        font-size: 1.3rem;
        .wrapper {
            border-top: 1px solid white;
            padding-top: 20px;
            border-left: none;
            float: none;
            padding-left: 0px;
            text-align: center;
        }
    }
}

//md
@media (max-width: 1023.98px) {

}

// sm
@media (max-width: 767.98px) { 

}

// xs
@media (max-width: 639.98px) { 

}

</style>